module.exports = __webpack_public_path__ + "img/103.80f70598.png";